/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useTheme } from '../theme';
import { ROUTES } from '../routes';
import { ItemCard } from './ItemCard';
import { itemService } from '../services/itemService';

const Trending: React.FC = () => {
  const theme = useTheme();
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    itemService.getTrendingItems(6)
      .then(res => {
        const data = res.data;
        if (data.data) {
          setItems(data.data.map((item: any) => ({
            ...item,
            image: item.imageUrl, // Map backend imageUrl to frontend image prop
            storeId: item.storeId
          })));
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching trending items:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="py-12 text-center">Loading trending items...</div>;
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <section className="py-12 border-t" style={{ borderColor: theme.colors.border }}>
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-3xl font-bold" style={{ color: theme.colors.text }}>
          Trending Near You
        </h2>
        <Link 
          to={ROUTES.SEARCH} 
          className="flex items-center gap-1 font-semibold hover:opacity-80" 
          style={{ color: theme.colors.primary }}
        >
          View All <ChevronRight size={18} />
        </Link>
      </div>

      <div className="flex gap-6 overflow-x-auto pb-6 no-scrollbar -mx-4 px-4 sm:mx-0 sm:px-0">
        {items.map((item) => (
          <div 
            key={item.id} 
            className="flex-shrink-0 w-64"
          >
            <ItemCard item={item} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Trending;
